import type { JSX } from "react";
import { FC } from "react";
import { P1 } from "../atoms/Paragraph";
import { HeadingSize, H2 } from "../atoms/Heading";
import styled from "styled-components";
import { StandardSection } from "../templates/StandardSection";

export const Column2: FC<
  React.PropsWithChildren<{
    id?: string;
    pt?: string;
    pb?: string;
    background?: string;
    title: string | JSX.Element;
    titleAlign?: string;
    body: string[] | JSX.Element;
    reverse?: boolean;
  }>
> = ({ id, pt, pb, background, title, titleAlign, body, reverse }) => {
  const Title = (
    <>
      {typeof title === "string" ? (
        <Heading align={titleAlign ? titleAlign : reverse ? "left" : "right"}>
          <H2 id={`${id}-column2-title`} size={HeadingSize.H1} align="inherit">
            {title}
          </H2>
        </Heading>
      ) : (
        <Heading
          id={`${id}-column2-title`}
          align={titleAlign ? titleAlign : reverse ? "left" : "right"}
        >
          {title}
        </Heading>
      )}
    </>
  );
  const Body = (
    <div>
      {Array.isArray(body) && body.length
        ? body.map((paragraph, index) => (
            <P1 pt={index === 0 && "0"} key={paragraph}>
              {paragraph}
            </P1>
          ))
        : body}
    </div>
  );

  return (
    <section id={id} aria-labelledby={`${id}-column2-title`}>
      <StandardSection pt={pt} pb={pb} background={background}>
        <Grid>
          {reverse ? (
            <>
              {Body}
              <Gutter />
              {Title}
            </>
          ) : (
            <>
              {Title}
              <Gutter />
              {Body}
            </>
          )}
        </Grid>
      </StandardSection>
    </section>
  );
};

const Heading = styled.div<{ align?: string }>`
  text-align: ${(p) => p.align || "right"};

  @media only screen and (max-width: 52rem) {
    text-align: left;
  }
`;

const Gutter = styled.div`
  display: none;
  height: 1.5rem;

  @media only screen and (max-width: 52rem) {
    display: block;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 8rem;

  @media only screen and (max-width: 52rem) {
    display: block;
  }
`;
